// import { auth } from '../config/firebaseConfig'; // Removed

// Define backend API base URL 
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Helper function to get auth token - REMOVED
// const getAuthToken = async () => { ... };

// Function to get all points of interest for a city
export const getPointsOfInterest = async (city, token) => { // Added token parameter
    try {
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const response = await fetch(`${API_BASE_URL}/locations/${encodeURIComponent(city)}`, { headers });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data.locations || [];
    } catch (error) {
        console.error("Error getting points of interest:", error);
        return [];
    }
};

// Function to get a single point of interest
export const getPointOfInterest = async (city, locationId, token) => { // Added token parameter
    try {
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const response = await fetch(`${API_BASE_URL}/locations/${encodeURIComponent(city)}/${encodeURIComponent(locationId)}`, { headers });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const location = await response.json();
        return location;
    } catch (error) {
        console.error("Error getting location:", error);
        return null;
    }
};

// Function for admin to add a point of interest
export const addPointOfInterest = async (city, point, token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');

        const response = await fetch(`${API_BASE_URL}/locations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ city, point })
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        return { success: true, id: result.id };
    } catch (error) {
        console.error("Error adding location:", error);
        return { success: false, error: error.message };
    }
};

// Function for admin to update a point of interest
export const updatePointOfInterest = async (city, locationId, updates, token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');
        
        const response = await fetch(`${API_BASE_URL}/locations/${encodeURIComponent(city)}/${encodeURIComponent(locationId)}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(updates)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        return { success: true };
    } catch (error) {
        console.error("Error updating location:", error);
        return { success: false, error: error.message };
    }
};

// Function for admin to delete a point of interest
export const deletePointOfInterest = async (city, locationId, token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');

        const response = await fetch(`${API_BASE_URL}/locations/${encodeURIComponent(city)}/${encodeURIComponent(locationId)}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        return { success: true };
    } catch (error) {
        console.error("Error deleting location:", error);
        return { success: false, error: error.message };
    }
};

// Admin function to add important locations from predefined data
export const addImportantLocations = async (token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');

        const response = await fetch(`${API_BASE_URL}/admin/locations/import-important`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        return { success: true };
    } catch (error) {
        console.error("Error adding important locations:", error);
        return { success: false, error: error.message };
    }
};

// Admin function to clean up all cities
export const cleanupAllCities = async (token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');

        const response = await fetch(`${API_BASE_URL}/admin/locations/cleanup`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        return { success: true };
    } catch (error) {
        console.error("Error during cleanup:", error);
        return { success: false, error: error.message };
    }
};

// Admin function to update additional info for important locations
export const updateAdditionalInfoForImportantLocations = async (token) => { // Added token parameter, removed getAuthToken call
    try {
        // const token = await getAuthToken(); // Removed
        if (!token) throw new Error('Authentication token is required.');

        const response = await fetch(`${API_BASE_URL}/admin/locations/update-info`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        
        return { success: true };
    } catch (error) {
        console.error("Error updating additional info:", error);
        return { success: false, error: error.message };
    }
}; 

// Suggest a new location (for verified students)
export const suggestLocation = async (token, city, locationData) => {
    try {
        const response = await fetch(`${API_BASE_URL}/locations/suggest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ city, locationData }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to submit suggestion.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error submitting location suggestion:', error);
        throw error;
    }
}; 